export default __webpack_public_path__ + "static/media/bruno-lucchi-modal.6e012de3.jpg";